module.exports = __webpack_public_path__ + "static/media/pinOrange.988d3c44.svg";